import { Stack, StackProps } from '@mui/material';
import { StyleObj } from '../../@types';
import { useJackpotPools } from '../../queries';
import SportsbookJackpotIcon from '../icons/SportsbookJackpotIcon';
import JackpotInfo from './JackpotInfo';
import JackpotSkeleton from './skeletons/JackpotSkeleton';
import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  listContainer: {
    width: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'start',
    overflowX: 'auto',
    p: 0.5,
    py: {
      xs: 0.5,
      md: 1,
    },
    gap: {
      xs: 0.5,
      md: 1,
    },
  },
};

type Props = StackProps;

const JackpotList = ({ sx, ...props }: Props) => {
  const { data: jackpotData, isLoading } = useJackpotPools();

  if (isLoading) {
    return <JackpotSkeleton sx={mergeSx(styles.listContainer, sx)} {...props} />;
  }

  if (!jackpotData?.length) {
    return null;
  }

  const maxAmount = Math.max(...jackpotData.map((pool) => pool.amount));

  return (
    <Stack sx={mergeSx(styles.listContainer, sx)} {...props}>
      {jackpotData?.map((jackpotPool, index) => {
        return (
          <JackpotInfo
            jackpotPool={jackpotPool}
            key={jackpotPool.id}
            icon={<SportsbookJackpotIcon type={jackpotPool.icon} size='small' />}
            maxAmount={maxAmount}
          />
        );
      })}
    </Stack>
  );
};

export default JackpotList;
